import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { EstudosCientificosPage } from './estudos-cientificos';
import { ComponentsModule } from '../../components/components.module';
import { PipesModule } from '../../pipes/pipes.module';
import { EstudosCientificosProvider } from './estudos-cientificos.provider';
import { DocumentosProvider } from '../../providers/documentos/documentos';
import { UserProvider } from '../../providers/user/user';

@NgModule({
  declarations: [
    EstudosCientificosPage,
  ],
  imports: [
    ComponentsModule,
    PipesModule,
    IonicPageModule.forChild(EstudosCientificosPage),
  ],
  providers:[
    EstudosCientificosProvider,
    DocumentosProvider,
    UserProvider
  ]
})
export class EstudosCientificosPageModule {

}



// WEBPACK FOOTER //
// ./src/pages/estudos-cientificos/estudos-cientificos.module.ts